"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TableRow = void 0;
const classnames_1 = __importDefault(require("classnames"));
const React = __importStar(require("react"));
const react_1 = require("react");
const index_1 = require("../../index");
const Table_1 = require("./Table");
const TableRow = ({ children, className, expired, cardIcon, }) => {
    const expandedTableValue = react_1.useContext(Table_1.ExpandedTableContext);
    const [tableRowExpanded, setTableRowExpanded] = react_1.useState(expandedTableValue.expandedDefault);
    const tableRowClassname = classnames_1.default({
        [className]: className,
        'table-row-expanded': tableRowExpanded,
        'table-row-expired': expired === true,
    });
    return (React.createElement("tr", { className: tableRowClassname },
        expandedTableValue.tableExpandable && (React.createElement("td", { className: "table-row-expandable-icon" }, cardIcon && React.createElement(index_1.Icon, { icon: cardIcon }))),
        children,
        expandedTableValue.tableExpandable && (React.createElement("td", { className: "table-row-expandable", onClick: () => setTableRowExpanded((old) => !old) },
            React.createElement(index_1.Icon, { icon: tableRowExpanded ? 'arrow_up' : 'arrow_down' })))));
};
exports.TableRow = TableRow;
//# sourceMappingURL=TableRow.js.map